module.exports = __webpack_public_path__ + "static/img/chanping8.d325401.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp/chanping8.jpg
// module id = VDPA
// module chunks = 0